import React from 'react'
import { Link } from 'react-router-dom'
export default function About() {
  return (
    <div className='flex items-center justify-center pt-[100px]'>
        <div className='section-width'>
        <h2 className='section-heading'>
        &lt;About_Me&gt;
        </h2>
        <p className='text-center body-color pt-4'>
        Hello! I'm a full-stack developer driven by passion and purpose. With a background in Mechatronics Engineering currently pursuing E-Mobility, I specialize in Application and Web Development, Artificial Intelligence (Machine Learning and Deep Learning), and Designing. My mission is to bring something good from my work, delivering that will make a difference in our society. Embark on this journey of creativity, innovation, and excellence.
            <br />Learn about me what motivates me and what i love do. Explore my motivations, hobbies and some secrets ...
        </p>
        <div className='flex items-center justify-center pt-4'>
        <Link to="/about" className='button-style'>
            Read More &#125;
        </Link>
        </div>
        </div>
    </div>
  )
}
